
/**
 * Message validation configuration and rules
 */

export interface ValidationRule {
  name: string;
  validate: (content: string) => boolean;
  errorMessage: string;
  severity: 'error' | 'warning';
}

export interface MessageValidationConfig {
  maxLength: number;
  minLength: number;
  forbiddenPatterns: RegExp[];
  customRules: ValidationRule[];
}

// Default validation configuration
export const DEFAULT_MESSAGE_VALIDATION: MessageValidationConfig = {
  maxLength: 10000,
  minLength: 1,
  forbiddenPatterns: [
    /^\s*$/, // Only whitespace
    /^(.)\1{50,}$/, // Repeated characters (spam detection)
  ],
  customRules: [
    {
      name: 'excessive_caps',
      validate: (content: string) => {
        const capsRatio = (content.match(/[A-Z]/g) || []).length / content.length;
        return capsRatio <= 0.7; // Max 70% caps
      },
      errorMessage: 'Message contains too many capital letters',
      severity: 'warning'
    },
    {
      name: 'excessive_punctuation',
      validate: (content: string) => {
        const punctuationCount = (content.match(/[!?]{3,}/g) || []).length;
        return punctuationCount === 0;
      },
      errorMessage: 'Avoid excessive punctuation',
      severity: 'warning'
    }
  ]
};

// Validation result type
export interface ValidationResult {
  isValid: boolean;
  error?: string;
  warnings?: string[];
  severity: 'none' | 'warning' | 'error';
}
